import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const PlayIcon = ({
  title = 'Play',
  className,
  viewBox = '0 0 24 24',
  color = 'currentColor',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent {...props} title={title} className={className} viewBox={viewBox} fill="none">
    <path
      clipRule="evenodd"
      d="M7 4v16l13-8L7 4Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </CreateIconComponent>
);

export default PlayIcon;
